export enum NavTabEnum {
    report = 1,
    actions = 2,
    documents = 4,
    administration = 5,
    dashboard = 0,
    None = -1
}
